// Square Web Payments SDK を CDN から動的ロードし、カード要素/3DSを扱う薄いラッパ。
// environment により sandbox / production の script URL を切り替える。
const SDK_URL = {
  sandbox: 'https://sandbox.web.squarecdn.com/v1/square.js',
  production: 'https://web.squarecdn.com/v1/square.js'
}

let sdkPromise = null

export function loadSquareSdk (environment) {
  if (window.Square) return Promise.resolve(window.Square)
  if (sdkPromise) return sdkPromise
  const url = SDK_URL[environment] || SDK_URL.sandbox
  sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script')
    s.src = url
    s.onload = () => (window.Square ? resolve(window.Square) : reject(new Error('Square SDK failed to load')))
    s.onerror = () => reject(new Error('Square SDK script error'))
    document.head.appendChild(s)
  })
  return sdkPromise
}

// vue-i18n の locale を Square がサポートする locale に対応付ける。
// Square Web Payments SDK は中国語に未対応(en/fr/ja/es のみ)なので cn は en-US にする。
// 指定しないとブラウザ言語の自動判定になり、中国語UIでもカード欄が日本語で出てしまう。
const SQUARE_LOCALE = { ja: 'ja-JP', en: 'en-US', cn: 'en-US' }

// カード要素を containerSelector にアタッチして card インスタンスを返す
export async function attachCard (applicationId, locationId, environment, containerSelector, locale) {
  const Square = await loadSquareSdk(environment)
  const payments = Square.payments(applicationId, locationId)
  // locale 指定は失敗してもカード入力自体は続行させる(決済をブロックしない)
  try {
    if (payments.setLocale && SQUARE_LOCALE[locale]) {
      await payments.setLocale(SQUARE_LOCALE[locale])
    }
  } catch (e) {
    console.warn('Square setLocale failed', e)
  }
  const card = await payments.card()
  await card.attach(containerSelector)
  return { payments, card }
}

// tokenize → 3DS(verifyBuyer) → { nonce, verificationToken }
export async function tokenizeWith3ds (payments, card, amountForVerification, currency, buyer) {
  const tokenResult = await card.tokenize()
  if (tokenResult.status !== 'OK') {
    const msg = (tokenResult.errors && tokenResult.errors[0] && tokenResult.errors[0].message) || 'tokenize failed'
    throw new Error(msg)
  }
  const nonce = tokenResult.token
  // カード保存(COF)の SCA。intent:'STORE'（StoreVerifyBuyerDetails）は amount/currencyCode を持たない
  // スキーマなので渡さない（amount/currencyCode は CHARGE intent 用）。
  let verificationToken = null
  try {
    const verify = await payments.verifyBuyer(nonce, {
      intent: 'STORE',
      billingContact: buyer || {}
    })
    verificationToken = verify ? verify.token : null
  } catch (e) {
    // verifyBuyer 未対応/失敗時は 3DS なしで続行（backend は verificationToken 任意受理）。
    verificationToken = null
  }
  return { nonce, verificationToken }
}
